
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { Observable } from "rxjs";
import { ServiceResult } from '@shared/helper/service-result';
import { FirebaseClientToken } from '@app/pages/notifications/models/notification-model';

@Injectable({
    providedIn: 'root'
})

export class NotificationsService extends HttpBaseService {

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'fire');
    }

    addClientToken(clientToken: FirebaseClientToken): Observable<ServiceResult> {
        return this.http.post<ServiceResult>(`${this.apiUrl}/AddClientToken`, clientToken);
    }
}
